import { Switch as MuiSwitch, Stack, Typography } from "@mui/material";

export const Switch = ({
  value,
  labels,
  onChangeValue,
}: {
  value: boolean;
  labels?: string[];
  onChangeValue: (value: boolean) => void;
}) => {
  return (
    <Stack direction="row" alignItems="center">
      {labels && labels[0] && (
        <Typography style={{ pointerEvents: "none" }}>{labels[0]}</Typography>
      )}

      <MuiSwitch
        checked={value}
        onChange={(event) => onChangeValue(event.target.checked)}
      />

      {labels && labels[1] && (
        <Typography style={{ pointerEvents: "none" }}>{labels[1]}</Typography>
      )}
    </Stack>
  );
};
